export const matchesAccept = (file: File, accept: string) =>
  accept.split(",").some((pattern) => {
    const type = pattern.trim();
    if (type.startsWith(".")) return file.name.toLowerCase().endsWith(type.toLowerCase());
    if (type.endsWith("/*")) return file.type.startsWith(type.slice(0, -1));
    return file.type === type;
  });
